/**
 * EngageXP Design System — Motion Tokens
 * Named duration + easing curves replacing inline magic values.
 *
 * @deprecated v1.2.0 — JS named-token exports retire at v1.3 in favor of
 *   direct CSS-var consumption from `tokens/motion.css` (canonical source).
 *   Migrate `duration.base` → `var(--duration-normal)`, `duration.moderate`
 *   → `var(--duration-slow)`, etc. See `_AGENTS/Claude/SIGIL/_canon-proposals/
 *   approved/2026-05-27_sigil_canon-proposal_lm-exp-curves_v1.md`.
 */

// ── DURATIONS ───────────────────────────────────────────────────────
export const duration = {
  micro: "100ms",
  fast: "150ms",
  base: "250ms",
  moderate: "400ms",
  dramatic: "600ms",
  cinematic: "1000ms",
} as const;

// ── EASING CURVES ───────────────────────────────────────────────────
export const easing = {
  swift:     "cubic-bezier(0.175, 0.885, 0.32, 1.1)",  // matches --ease-swift
  smooth:    "cubic-bezier(0.4, 0, 0.2, 1)",            // matches --ease-smooth
  dramatic:  "cubic-bezier(0.77, 0, 0.175, 1)",         // matches --ease-dramatic
  epic:      "cubic-bezier(0.86, 0, 0.07, 1)",          // matches --ease-epic
  legendary: "cubic-bezier(0.16, 1, 0.3, 1)",           // matches --ease-legendary
  spring:    "cubic-bezier(0.34, 1.56, 0.64, 1)",       // matches --ease-spring
  bounce:    "cubic-bezier(0.34, 1.3, 0.64, 1)",        // matches --ease-bounce
} as const;

// ── STAGGER SPEEDS ──────────────────────────────────────────────────
export const stagger = {
  fast: "30ms",
  base: "60ms",
  slow: "100ms",
} as const;

export const motion = { duration, easing, stagger } as const;

export default motion;
